import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="System Design Interview by Alex Xu"
        desc="An insider's guide to system design interviews"
        keyword="system design interview, alex xu, system design, distributed systems, scalability"
        image="/images/books/system-design-interview.jpg"
        pageType="book"
        author="Alex Xu"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/system-design-interview.jpg"
                alt="system design interview alex xu engineering book"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                System Design Interview
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Alex Xu</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Alex Xu provides a step-by-step framework for tackling system design
                questions in technical interviews. The book covers how to approach
                open-ended design problems, communicate effectively with interviewers,
                and make sound trade-offs when designing large-scale systems.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Through real-world examples, the book walks through the design of
                well-known systems such as rate limiters, URL shorteners, chat systems,
                notification services, and news feeds. Each chapter breaks down the
                problem into manageable steps, from requirements gathering to high-level
                architecture and deep dives into specific components.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Whether you are preparing for interviews or simply want to strengthen
                your understanding of how large-scale systems are built, this book
                offers practical knowledge that applies far beyond the interview room.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
